import {Box, Button, Snackbar} from "@mui/material";
import SearchInput from "../../components/SearchInput";
import LoadingScreen from "../../components/LoadingScreen";
import CustomTable from "../../components/TableColumnShapes/CustomTable";
import {Alert} from "@mui/lab";
import React, {FC, useEffect, useState} from "react";
import StyledFlexBox from "../../components/StyledFlexBox";
import {ColumnActionProps} from "../../types/ColumnActionProps";
import RoleListColumnsShape from "../../components/TableColumnShapes/RoleListColumnsShape";
import {getRoles} from "../../api/role";
import CreateRoleFormDialog from "./CreateRoleDialog";
import useTitle from "../../hooks/useTitle";
import DeleteRoleDialog from "./DeleteRoleDialog";
import {Role} from "../../types/Role";

const RolesPage: FC = () => {
    useTitle("Rôles")
    const [roles, setRoles] = useState<Role[]>([])
    const [action, setAction] = useState<"create" | "update">()
    const [currentRole, setCurrentRole] = useState<Role>({})
    const [createRoleFormOpen, setCreateRoleFormOpen] = useState(false)
    const [deleteRoleDialogOpen, setDeleteRoleDialogOpen] = useState(false)
    const [showRoleActionResultFeedback, setShowRoleActionResultFeedback] = useState(false)
    const [loadingData, setLoadingData] = useState(false)
    const [actionResult, setActionResult] = useState<{ status: "success" | "error", message?: string }>()
    const loadData = () => {
        setLoadingData(true)
        getRoles()
            .then(value => {
                setLoadingData(false)
                setRoles(value.data)
            }).catch(() => {
            setLoadingData(false)
        })
    }
    const roleColumnActionProps: ColumnActionProps<Role> = {
        onDeleteAction: (item) => {
            setCurrentRole(item)
            setDeleteRoleDialogOpen(true)
        },
        onEditAction: (item) => {
            setCurrentRole(item)
            setCreateRoleFormOpen(true)
            setAction("update")
        }
    }
    const handleCreateRole = () => {
        setAction("create")
        setCreateRoleFormOpen(true)
    }

    const handleSnackbarClose = () => {
        setShowRoleActionResultFeedback(false)
    }


    useEffect(() => {
        loadData()
    }, [])

    return (<Box pt={2} pb={4}>
            <StyledFlexBox>
                <Button variant="contained" onClick={handleCreateRole}>
                    Créer un rôle
                </Button>
            </StyledFlexBox>

            {loadingData ? <LoadingScreen/> :
                <CustomTable columnShape={RoleListColumnsShape(roleColumnActionProps)} data={roles}/>}

            {createRoleFormOpen &&
                <CreateRoleFormDialog initialData={currentRole}
                                      action={action}
                                      onCreateEntityStatusChange={(status, message) => {
                                          if (status === "success")
                                              loadData()

                                          setActionResult({
                                              status,
                                              message
                                          })
                                          setShowRoleActionResultFeedback(true)
                                      }}
                                      onClose={() => {
                                          setCurrentRole(null)
                                          setCreateRoleFormOpen(false)
                                      }}
                                      open={true}/>}

            <DeleteRoleDialog
                onClose={() => {
                    setDeleteRoleDialogOpen(false)
                }} target={currentRole}
                open={deleteRoleDialogOpen}
                onEntityActionStatusChange={(status, message) => {
                    if (status === "success")
                        loadData()

                    setActionResult({
                        status,
                        message
                    })
                    setShowRoleActionResultFeedback(true)
                    setCurrentRole(null)
                }}/>

            <Snackbar open={showRoleActionResultFeedback} autoHideDuration={6000} onClose={handleSnackbarClose}>
                <Alert
                    onClose={handleSnackbarClose}
                    severity={actionResult?.status}
                    variant="filled"
                    sx={{width: '100%'}}>
                    {actionResult?.message || "Rôle crée avec succès"}
                </Alert>
            </Snackbar>

        </Box>
    )

}

export default RolesPage